import { loadImage, vimeoIdFromUrl } from './helpers';


const $ = window.jQuery;
const Modernizr = window.Modernizr;
const $newsSingle = $('.news-single');

if ($newsSingle.length !== 0) {

	const $newsImage = $('.news-single__image');
	const $newsVideo = $('.news-single__extra__video');

	if ($newsImage.length !== 0) {
		$newsImage.each(function() {
			const $this = $(this);
			const src = $this.attr('data-src');
			const alt = $this.attr('alt');
			loadImage(src)
				.then(() => {
					if (Modernizr.objectfit) {
						$this.attr('src', src);
					} else {
						const $div = $('<div class="news-single__image news-single__image--background"></div>');
						$div.attr('role', 'image'); // accesibility stuff
						$div.attr('aria-label', alt);
						$div.css('background-image', `url('${src}')`);
						$this.replaceWith($div);
					}
				})
				.catch((err) => {
					console.log('Error loading image', err);
				});
		});
	}

}
